module.exports = __webpack_public_path__ + "img/alertbuttonPressed.6f9ad4a7.png";